
import React, { useState, useEffect } from "react";
import moment from "moment";
import staticflightsdata from "../Data/ReturnData.json";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import ModifyFlightSearch from "./ModifyFlightSearch";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { ShareEmail } from "../../Common/Helpers/ShareEmail";
import FlightLoader from "../../Common/Layout/FlightLoader";
import BookingConfirmationModal from "./BookingConfirmationModal";
import { RiPriceTag3Line, RiExternalLinkLine, RiInformationLine } from "react-icons/ri";

const Flights = () => {
  const { user, loading, currencies } = useAuth();
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [pageLoading, setPageLoading] = useState(false);
  const [currency, setCurrency] = useState(user?.currency);
  const [flightData, setFlightData] = useState([]);
  const [searchQuery, setSearchQuery] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [expandedFlights, setExpandedFlights] = useState({}); // Track which flights have fares expanded
  const [selectedFares, setSelectedFares] = useState({}); // Track selected fare per flight
  const [showBookingModal, setShowBookingModal] = useState(false);

  // New states for Series Fares
  const [seriesFaresCount, setSeriesFaresCount] = useState(0);
  const [loadingSeriesFares, setLoadingSeriesFares] = useState(false);

  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
  };
  /* List Start */
  const [filters, setFilters] = useState({
    airlines: [],
    priceRange: [0, 9999999],
    departureTime: "",
    stops: [],
  });
  const getAirlines = () => {
    const set = new Set();
    flightData.forEach((tab) =>
      tab.dcFlightLegs.forEach((flight) =>
        set.add(flight.dcDisplayLegs[0]?.airlineData?.airline)
      )
    );
    return Array.from(set);
  };
  const handleFilterChange = (type, value) => {
    setFilters((prev) => {
      if (type === "airlines" || type === "stops") {
        const updated = prev[type].includes(value)
          ? prev[type].filter((v) => v !== value)
          : [...prev[type], value];
        return { ...prev, [type]: updated };
      } else if (type === "priceRange") {
        return { ...prev, priceRange: value };
      } else {
        return { ...prev, [type]: value };
      }
    });
  };
  const applyFilters = (flights) => {
    return flights.filter((flight) => {
      const displayLeg = flight.dcDisplayLegs[0];
      const airline = displayLeg?.airlineData?.airline;
      const stops = displayLeg?.stops;
      const price = flight.totalPrice || 0;
      const departureHour = new Date(
        displayLeg?.startSegment.departureDateTime
      ).getHours();

      return (
        (filters.airlines.length === 0 || filters.airlines.includes(airline)) &&
        (filters.stops.length === 0 || filters.stops.includes(stops)) &&
        price >= filters.priceRange[0] &&
        price <= filters.priceRange[1] &&
        (!filters.departureTime ||
          (filters.departureTime === "morning" &&
            departureHour >= 5 &&
            departureHour < 12) ||
          (filters.departureTime === "afternoon" &&
            departureHour >= 12 &&
            departureHour < 17) ||
          (filters.departureTime === "evening" &&
            departureHour >= 17 &&
            departureHour < 21) ||
          (filters.departureTime === "night" &&
            (departureHour >= 21 || departureHour < 5)))
      );
    });
  };
  const handleClearFilters = () => {
    setFilters({
      airlines: [],
      priceRange: [0, 9999999],
      departureTime: "",
      stops: [],
    });
  };
  function getTimeFromMins(mins) {
    var h = (mins / 60) | 0,
      m = mins % 60 | 0;
    var durationformat = h + "h " + m + "m";
    return durationformat;
  }
  const handleToggleFares = (supplierLegId) => {
    setExpandedFlights((prev) => ({
      ...prev,
      [supplierLegId]: !prev[supplierLegId],
    }));
  };
  const handleSelectFare = (
    journeyType,
    flightLeg,
    selectedSupplierPriceId
  ) => {
    const selectedFare = flightLeg.dcPriceDetails.find(
      (fare) => fare.supplierPriceId === selectedSupplierPriceId
    );

    if (selectedFare) {
      setSelectedFares((prev) => ({
        ...prev,
        [journeyType]: {
          flightLeg,
          fare: selectedFare,
        },
      }));
    }
  };

  const formatFlightDetails = (flightLeg) => {
    const displayLeg = flightLeg.dcDisplayLegs[0];
    const segments = flightLeg.dcSegments;
    const viaCities =
      segments.length > 1
        ? segments
          .slice(0, -1)
          .map((seg) => `(${seg.tFArrivalData.airportCode})`)
          .join(", ")
        : "";

    return `
ONWARD: 🛫 ${displayLeg.airlineData.airline} (${displayLeg.airlineData.flightNumber
      }) : 
${displayLeg.startSegment.airportCode} (${displayLeg.startSegment.city}) - ${displayLeg.endSegment.airportCode
      } (${displayLeg.endSegment.city})${viaCities ? `( via ${viaCities})` : ""}
Departure: ${moment(displayLeg.startSegment.departureDateTime).format(
        "ddd, DD MMM YY HH:mm"
      )}
Arrival: ${moment(displayLeg.endSegment.arrivalDateTime).format(
        "ddd, DD MMM YY HH:mm"
      )}
Duration: ${getTimeFromMins(displayLeg.totalDuration)} / ${displayLeg.stops === 0
        ? "Non-stop"
        : `${displayLeg.stops} stop${displayLeg.stops > 1 ? "s" : ""}`
      }

TOTAL PRICE: ${currency} ${flightLeg.totalPrice.toLocaleString("en-IN")}`;
  };

  const shareViaWhatsApp = (flightLeg) => {
    const passengerDetails = [
      params.adults > 0 &&
      `${params.adults} Adult${params.adults > 1 ? "s" : ""}`,
      params.kids > 0 && `${params.kids} Kid${params.kids > 1 ? "s" : ""}`,
      params.infants > 0 &&
      `${params.infants} Infant${params.infants > 1 ? "s" : ""}`,
    ]
      .filter(Boolean)
      .join(" | ");

    const message = `Hello Traveler, please find your flight details:

Journey: ${flightData[activeTab]?.locationFrom} - ${flightData[activeTab]?.locationTo
      }
Passengers: ${passengerDetails}
Cabin Class: ${flightLeg.dcPriceDetails[0]?.dcAdults?.cabinClass}

FLIGHT DETAILS:
--------------------------------------------------------------------------------
${formatFlightDetails(flightLeg)}
--------------------------------------------------------------------------------
Thank you for choosing ${user?.brandName}

In case of any support:
☎️ Contact : ${user?.phoneNumber}
✉ Email     : ${user?.email}`;

    window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`, "_blank");
  };
  const shareViaEmail = (flightLeg) => {
    const subject = `Your Flight Details: ${flightData[activeTab]?.locationFrom} to ${flightData[activeTab]?.locationTo}`;
    const body = `Hello,

Please find details with regards to your flight(s) query for:
${flightData[activeTab]?.locationFrom} - ${flightData[activeTab]?.locationTo}
${params.adults} Adult${params.adults > 1 ? "s" : ""}
${flightLeg.dcPriceDetails[0]?.fareIdentifier}

Below mentioned prices are the total price(s) inclusive of taxes:
--------------------------------------------------------------------------------
${formatFlightDetails(flightLeg)}
--------------------------------------------------------------------------------
Thank you for choosing ${user?.brandName}

In case of any support:
Contact: ${user?.phoneNumber}
Email: ${user?.email}

Best regards,
${user?.name}`;
    ShareEmail({
      subject,
      body,
      // to: "customer@example.com", // Optional
      preferGmail: false // Set to true if you want to *always* open Gmail
    });
    //window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const BindPageData = (searchQuery) => {
    setPageLoading(true);
    GetFlights(searchQuery);
    // Fetch series fares count
    fetchSeriesFaresCount(searchQuery);
  };

  // Function to fetch series fares count
  const fetchSeriesFaresCount = async (searchQuery) => {
    try {
      setLoadingSeriesFares(true);

      // Get search parameters
      const firstTrip = searchQuery.flightTravelerPoints?.[0];
      if (!firstTrip) {
        setSeriesFaresCount(0);
        return;
      }

      const from = firstTrip.from || '';
      const to = firstTrip.to || '';
      const date = firstTrip.departureDate || '';
      const pax = (searchQuery.adults || 0) + (searchQuery.kids || 0) + (searchQuery.infants || 0);

      if (!from || !to || !date) {
        setSeriesFaresCount(0);
        return;
      }

      // Call series fares count API
      const response = await apiService.getAll(
        `${config.SERIESFARESEARCH}?from=${from}&to=${to}&date=${date}&pax=${pax}`
      );

      if (response && response.count !== undefined) {
        setSeriesFaresCount(response.count);
      } else {
        setSeriesFaresCount(0);
      }
    } catch (error) {
      console.error("Error fetching series fares count:", error);
      setSeriesFaresCount(0);
    } finally {
      setLoadingSeriesFares(false);
    }
  };

  // // Function to handle viewing series fares
  // const handleViewSeriesFares = () => {
  //   if (!state?.searchQuery) return;

  //   const searchQuery = state.searchQuery;
  //   const firstTrip = searchQuery.flightTravelerPoints?.[0];

  //   if (!firstTrip) return;

  //   const seriesSearchData = {
  //     from: firstTrip.from || '',
  //     to: firstTrip.to || '',
  //     date: firstTrip.departureDate || '',
  //     pax: (searchQuery.adults || 0) + (searchQuery.kids || 0) + (searchQuery.infants || 0),
  //     cabinClass: searchQuery.cabinClass || 'ECONOMY',
  //     journeyType: searchQuery.journeyType || 'ONEWAY',
  //     isDomestic: searchQuery.isDomestic || 'DOMESTIC'
  //   };

  //   // Navigate to series fares agent search
  //   navigate("/flights/series-fares", { 
  //     state: { 
  //       searchQuery: seriesSearchData,
  //       passengerCount: seriesSearchData.pax
  //     } 
  //   });
  // };

  // In Flights.js - Update the handleViewSeriesFares function
  const handleViewSeriesFares = () => {
    if (!state?.searchQuery) return;

    const searchQuery = state.searchQuery;
    const firstTrip = searchQuery.flightTravelerPoints?.[0];

    if (!firstTrip) return;

    // Prepare the search data
    const seriesSearchData = {
      from: firstTrip.from || '',
      to: firstTrip.to || '',
      date: firstTrip.departureDate || '',
      pax: (searchQuery.adults || 0) + (searchQuery.kids || 0) + (searchQuery.infants || 0),
      cabinClass: searchQuery.cabinClass || 'ECONOMY',
      journeyType: searchQuery.journeyType || 'ONEWAY',
      isDomestic: searchQuery.isDomestic || 'DOMESTIC'
    };

    // Navigate to series fares page
    navigate("/seriesfare/agent-search", {
      state: {
        searchQuery: seriesSearchData,
        passengerCount: seriesSearchData.pax,
        // Add these to help with auto-search
        shouldAutoSearch: true, // Flag to indicate auto-search should happen
        fromAirportCode: firstTrip.from,
        toAirportCode: firstTrip.to,
        travelDate: firstTrip.departureDate
      }
    });
  };

  const GetFlights = async (searchQuery) => {
    var result = await apiService.post(config.SEARCHFLIGHTS, searchQuery);
    console.log(result);
    if (result.length > 0) {
      const defaultSelected = {};
      const sortedData = result.map((destination) => {
        const sortedLegs = [...destination.dcFlightLegs].sort(
          (a, b) => a.totalPrice - b.totalPrice
        );

        const cheapestLeg = sortedLegs[0];
        let matchingFare = null;

        if (cheapestLeg?.dcPriceDetails?.length > 0) {
          matchingFare = [...cheapestLeg.dcPriceDetails].sort(
            (a, b) => a.totalPrice - b.totalPrice
          )[0];
        }

        if (cheapestLeg && matchingFare) {
          defaultSelected[destination.journeyType] = {
            flightLeg: cheapestLeg,
            fare: matchingFare,
          };
        }

        return {
          ...destination,
          dcFlightLegs: sortedLegs,
        };
      });

      setFlightData(sortedData);
      setSelectedFares(defaultSelected);
    } else {
      alert("No flights found");
    }
    setPageLoading(false);
  };
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(selectedFares);
  //   const payload = Object.values(selectedFares).map(({ flightLeg, fare }) => ({
  //     flightLeg: flightLeg,
  //     fare: fare,
  //   }));
  //   navigate(
  //     "/flightdetails/" +
  //     params.adults +
  //     "/" +
  //     params.kids +
  //     "/" +
  //     params.infants +
  //     "/" +
  //     params.isDomestic,
  //     { state: { searchQuery, payload } }
  //   );
  // };
  const handleSubmit = (e) => {
    e.preventDefault();
    // Instead of navigating, just open the modal
    setShowBookingModal(true);
  };

  const handleContinueBooking = () => {
    setShowBookingModal(false); // Close the modal first
    const payload = Object.values(selectedFares).map(({ flightLeg, fare }) => ({
      flightLeg: flightLeg,
      fare: fare,
    }));
    navigate(
      "/flightdetails/" +
      params.adults +
      "/" +
      params.kids +
      "/" +
      params.infants +
      "/" +
      params.isDomestic,
      { state: { searchQuery, payload } }
    );
  };
  // KEY CHANGE 5: Create a function to handle "Book with Supplier"
  const handleBookWithSupplier = () => {
    setShowBookingModal(false);
    // You will add the actual supplier URL here later
    // For now, it opens a blank new tab
    window.open('', '_blank');
    // You could also show a toast message
    // toast.info("Redirecting to supplier portal...");
  };

  /*List End */
  /* useEffect(() => {
    if (!staticflightsdata || staticflightsdata.length === 0) return;

    const defaultSelected = {};
    const sortedData = staticflightsdata.map((destination) => {
      const sortedLegs = [...destination.dcFlightLegs].sort(
        (a, b) => a.totalPrice - b.totalPrice
      );

      const cheapestLeg = sortedLegs[0];
      let matchingFare = null;

      if (cheapestLeg?.dcPriceDetails?.length > 0) {
        matchingFare = [...cheapestLeg.dcPriceDetails].sort(
          (a, b) => a.totalPrice - b.totalPrice
        )[0];
      }

      if (cheapestLeg && matchingFare) {
        defaultSelected[destination.journeyType] = {
          flightLeg: cheapestLeg,
          fare: matchingFare,
        };
      }

      return {
        ...destination,
        dcFlightLegs: sortedLegs,
      };
    });

    setFlightData(sortedData);
    setSelectedFares(defaultSelected);
 }, [staticflightsdata]); */

  const handleSearch = (query) => {
    setSearchQuery(query);
    setPageLoading(true);
    BindPageData(query);
  };
  useEffect(() => {
    if (state === null) {
      navigate('/flight/search');
    } else if (params === null) {
      navigate('/flight/search');
    } else if (state.searchQuery === null) {
      navigate('/flight/search');
    } else {
      setSearchQuery(state.searchQuery);
      setPageLoading(true);
      BindPageData(state.searchQuery);
    }
    if (loading) return <p>Loading...</p>;
    if (!user) {
      navigate("/");
    }
  }, []);
  return (
    <div id="layout-wrapper">
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            {/* start page title */}
            <div className="card">
              <ModifyFlightSearch onSearch={handleSearch}></ModifyFlightSearch>
            </div>
            {/* end page title */}
            {pageLoading === true ? (
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <div className="branded-loader-wrapper">
                      <FlightLoader />
                    </div>
                  </div>
                </div>
              </div>) : (
              <div className="row">
                <div className="col-3">
                  <div className="card">
                    <div className="card-header">
                      <div className="d-flex mb-0">
                        <div className="flex-grow-1">
                          <h5 className="fs-16">Filters</h5>
                        </div>
                        <div className="flex-shrink-0">
                          <Link
                            onClick={handleClearFilters}
                            className="text-decoration-underline"
                          >
                            Clear All
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">

                      {/* Series Fares Filter */}
                      <div
                        className="series-fares-filter"
                        style={{
                          marginTop: "15px",
                          padding: "12px",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "8px",
                          borderLeft: "4px solid #0dcaf0"
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            <RiPriceTag3Line className="me-2 text-info" />
                            <p className="text-muted text-uppercase fs-12 fw-medium mb-0">
                              Series Fares
                            </p>
                          </div>
                          <div className="text-end">
                            {loadingSeriesFares ? (
                              <span className="spinner-border spinner-border-sm text-info" role="status"></span>
                            ) : (
                              <span className="badge bg-info rounded-pill">{seriesFaresCount}</span>
                            )}
                          </div>
                        </div>

                        <div className="text-muted small mb-2" style={{ fontSize: "11px" }}>
                          Guaranteed seat packages at fixed prices
                        </div>

                        <button
                          type="button"
                          className="btn btn-info btn-sm w-100"
                          onClick={handleViewSeriesFares}
                          disabled={seriesFaresCount === 0 || loadingSeriesFares}
                          style={{
                            borderColor: "#0dcaf0",
                            color: "#010d0fff",
                            fontSize: "12px",
                            padding: "5px 10px",
                            borderRadius: "5px"
                          }}
                        >
                          {loadingSeriesFares ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                              Checking...
                            </>
                          ) : (
                            <>
                              <RiExternalLinkLine className="me-1" />
                              {seriesFaresCount > 0
                                ? `View ${seriesFaresCount} Series Fare${seriesFaresCount > 1 ? 's' : ''}`
                                : 'No Series Fares'}
                            </>
                          )}
                        </button>

                        {seriesFaresCount > 0 && (
                          <div className="mt-2 text-info small" style={{ fontSize: "11px" }}>
                            <RiInformationLine className="me-1" />
                            Click to view fixed-price guaranteed seats
                          </div>
                        )}
                      </div>

                      <div style={{ marginTop: "10px" }}>
                        <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                          Stops
                        </p>
                        {[0, 1, 2].map((stop) => (
                          <div key={stop}>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={filters.stops.includes(stop)}
                                onChange={() => handleFilterChange("stops", stop)}
                              />
                              {stop} Stop{stop !== 1 ? "s" : ""}
                            </label>
                          </div>
                        ))}
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                          Departure Time
                        </p>
                        {["morning", "afternoon", "evening", "night"].map(
                          (slot) => (
                            <div key={slot}>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <input
                                  type="radio"
                                  name="departureTime"
                                  checked={filters.departureTime === slot}
                                  onChange={() =>
                                    handleFilterChange("departureTime", slot)
                                  }
                                />
                                {slot.charAt(0).toUpperCase() + slot.slice(1)}
                              </label>
                            </div>
                          )
                        )}
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                          Price Range
                        </p>
                        <input
                          type="range"
                          min={0}
                          max={9999999}
                          value={filters.priceRange[1]}
                          onChange={(e) =>
                            handleFilterChange("priceRange", [
                              0,
                              parseInt(e.target.value),
                            ])
                          }
                        />
                        <div>Up to INR {filters.priceRange[1]}</div>
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        <p className="text-muted text-uppercase fs-12 fw-medium mb-2">
                          Airlines
                        </p>
                        {getAirlines().map((airline, idx) => (
                          <div key={idx}>
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={filters.airlines.includes(airline)}
                                onChange={() =>
                                  handleFilterChange("airlines", airline)
                                }
                              />
                              {airline}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* end card */}
                </div>
                <div className="col-9">
                  <div className="card mb-3 border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                    <div className="card-header border-0 bg-white py-3">
                      <ul className="nav nav-pills arrow-navtabs nav-success card-header-tabs border-bottom-0" role="tablist">
                        {flightData.length > 0 && flightData.map((item, index) => (
                          <li className="nav-item" key={index}>
                            <a className={`nav-link fw-bold px-4 py-2 rounded-pill ${activeTab === index ? "active shadow-sm" : "text-muted"}`}
                              onClick={() => setActiveTab(index)} style={{ cursor: 'pointer' }}>
                              {item.locationFrom} ➝ {item.locationTo}
                              <span className="ms-2 badge rounded-pill bg-light text-dark border fw-normal">{item.dcFlightLegs.length} flights</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* MAIN FLIGHT LIST CONTAINER */}
                  <div className="d-flex flex-column gap-4">
                    {applyFilters((flightData.length > 0 && flightData[activeTab]?.dcFlightLegs) || [])?.map((flightLeg, idx) => {
                      const mainLeg = flightLeg.dcDisplayLegs[0];
                      const isSelected = selectedFares[flightData[activeTab]?.journeyType]?.flightLeg?.supplierLegId === flightLeg.supplierLegId;
                      const minPrice = Math.min(...flightLeg.dcPriceDetails.map(fare => fare.totalPrice || Infinity));
                      const fareIdentifier = flightLeg.dcPriceDetails[0]?.fareIdentifier;

                      return (
                        <div key={idx} className="flight-item-wrapper">
                          {/* THE MAIN FLIGHT CARD */}
                          <div className="card border-0 shadow-sm overflow-hidden"
                            style={{
                              borderRadius: '20px',
                              transition: 'all 0.3s ease',
                              borderLeft: isSelected ? '6px solid #2563EB' : '6px solid #E2E8F0',
                              background: '#fff'
                            }}>
                            <div className="card-body p-0">
                              <div className="row g-0 align-items-center">

                                {/* 1. Airline Info */}
                                <div className="col-lg-2 p-4 text-center border-end bg-light-subtle">
                                  <div className="bg-white rounded-3 p-2 d-inline-block shadow-sm mb-2">
                                    <img src={"/assets/images/airlinelogos/" + mainLeg?.airlineData?.airlineCode + ".png"}
                                      alt={mainLeg?.airlineData?.airlineCode} style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
                                  </div>
                                  <h6 className="fw-bold text-dark mb-0">{mainLeg?.airlineData?.flightNumber}</h6>
                                  <p className="text-muted small mb-0 fw-medium">{mainLeg?.airlineData?.airline}</p>
                                </div>

                                {/* 2. Timeline Visual */}
                                <div className="col-lg-7 p-4">
                                  <div className="row align-items-center text-center">
                                    <div className="col-4">
                                      <h3 className="fw-bolder text-dark mb-1">{moment(mainLeg?.startSegment?.departureDateTime).format("HH:mm")}</h3>
                                      <div className="badge bg-soft-primary text-primary px-3 rounded-pill mb-1 fs-6">{mainLeg?.startSegment?.airportCode}</div>
                                      <p className="text-muted small mb-0">{moment(mainLeg?.startSegment?.departureDateTime).format("DD MMM YY")}</p>
                                    </div>
                                    <div className="col-4 px-2 text-center">
                                      <p className="text-muted small mb-1 fw-bold">{getTimeFromMins(mainLeg.totalDuration)}</p>
                                      <div className="d-flex align-items-center justify-content-center gap-1 opacity-75">
                                        <i className="ri-flight-takeoff-line text-primary fs-5"></i>
                                        <div className="flex-grow-1 border-bottom border-primary border-dashed" style={{ height: '1px' }}></div>
                                        <i className="ri-flight-land-line text-primary fs-5"></i>
                                      </div>
                                      <p className={`small mt-1 mb-0 fw-bold ${mainLeg.stops === 0 ? 'text-success' : 'text-warning'}`}>
                                        {mainLeg.stops === 0 ? "Non-Stop" : `${mainLeg.stops} Stop`}
                                      </p>
                                    </div>
                                    <div className="col-4">
                                      <h3 className="fw-bolder text-dark mb-1">{moment(mainLeg?.endSegment?.arrivalDateTime).format("HH:mm")}</h3>
                                      <div className="badge bg-soft-primary text-primary px-3 rounded-pill mb-1 fs-6">{mainLeg?.endSegment?.airportCode}</div>
                                      <p className="text-muted small mb-0">{moment(mainLeg?.endSegment?.arrivalDateTime).format("DD MMM YY")}</p>
                                    </div>
                                  </div>
                                </div>

                                {/* 3. Pricing & Select */}
                                <div className="col-lg-3 p-4 bg-light-subtle border-start text-center d-flex flex-column justify-content-center gap-2">
                                  <div className="mb-2">
                                    <span className="badge bg-success text-white px-2 py-1 mb-1 shadow-sm">{fareIdentifier}</span>
                                    <div className="d-flex align-items-baseline justify-content-center">
                                      <span className="text small fw-bold me-1">{currency}</span>
                                      <h2 className="fw-bolder text-dark mb-0">{minPrice.toLocaleString('en-IN')}</h2>
                                    </div>
                                    <div className="small text fw-bold mt-1">Via {flightLeg.supplierName}</div>
                                  </div>
                                  <div className="d-grid gap-2">
                                    {isSelected ? (
                                      <button className="btn btn-success fw-bold rounded-pill shadow-sm py-2" disabled>SELECTED</button>
                                    ) : (
                                      <button className="btn btn-primary fw-bold rounded-pill shadow-sm py-2" onClick={() => handleSelectFare(flightData[activeTab]?.journeyType, flightLeg, flightLeg.dcPriceDetails[0].supplierPriceId)}>SELECT</button>
                                    )}
                                    <button className={`btn btn-sm fw-bold rounded-pill py-2 ${expandedFlights[flightLeg.supplierLegId] ? 'btn-dark' : 'btn-outline-warning text-dark'}`}
                                      onClick={() => handleToggleFares(flightLeg.supplierLegId)}>
                                      {expandedFlights[flightLeg.supplierLegId] ? "HIDE FARES" : "COMPARE FARES"}
                                    </button>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-center gap-3 mt-2 border-top pt-2">
                                    <Link onClick={() => shareViaWhatsApp(flightLeg)} className="text-success"><i className="ri-whatsapp-fill fs-5"></i></Link>
                                    <Link onClick={() => shareViaEmail(flightLeg)} className="text-primary"><i className="ri-mail-fill fs-5"></i></Link>
                                    <Link className="text small fw-bolder text-decoration-none" data-bs-toggle="modal" data-bs-target={"#flight" + flightLeg.supplierLegId}>DETAILS</Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* DESIGN 4 UPDATED: HORIZONTAL FILMSTRIP WITH FULL DATA & FIXES */}
                          {expandedFlights[flightLeg.supplierLegId] && (
                            <div className="mt-2 mx-3 border-top bg-light shadow-inner"
                              style={{ marginTop: '-15px', paddingTop: '10px', borderRadius: '0 0 20px 20px' }}>

                              <div className="p-3">
                                <div className="d-flex align-items-center justify-content-between mb-3 px-1">
                                  <div className="small fw-bold text-dark text-uppercase ls-1">
                                    <i className="ri-arrow-left-right-line me-2 text-primary"></i>
                                    Compare {flightLeg.dcPriceDetails.length} Supplier Combinations
                                  </div>
                                  <div className="small text-muted d-none d-md-block">Scroll horizontally to view more →</div>
                                </div>

                                <div className="d-flex flex-nowrap overflow-auto gap-3 pb-3 custom-horizontal-scrollbar" style={{ cursor: 'grab' }}>
                                  {flightLeg.dcPriceDetails.sort((a, b) => a.totalPrice - b.totalPrice).map((fare, i) => {
                                    const isCheapest = i === 0;
                                    const isFareSelected = selectedFares[flightData[activeTab]?.journeyType]?.fare?.supplierPriceId === fare.supplierPriceId;

                                    return (
                                      <div
                                        key={i}
                                        onClick={() => handleSelectFare(flightData[activeTab]?.journeyType, flightLeg, fare.supplierPriceId)}
                                        className="flex-shrink-0 shadow-sm transition-all"
                                        style={{
                                          width: '240px', // Adjusted for longer labels
                                          borderRadius: '16px',
                                          background: isFareSelected ? '#2563EB' : '#FFFFFF',
                                          color: isFareSelected ? '#FFFFFF' : 'inherit',
                                          border: isFareSelected ? '2px solid #2563EB' : '1px solid #E2E8F0',
                                          cursor: 'pointer',
                                          padding: '12px'
                                        }}
                                      >
                                        {/* Header: Supplier & Identifier */}
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                          <div className="lh-1">
                                            <div className={`fw-bold small mb-1 ${isFareSelected ? 'text-white' : 'text-dark'}`}>{fare.supplierName}</div>
                                            <span className={`badge px-2 py-1 ${isFareSelected ? 'bg-white text-primary shadow-sm' : 'bg-soft-primary text-primary'}`} style={{ fontSize: '8px' }}>
                                              {fare.fareIdentifier}
                                            </span>
                                          </div>
                                          {isCheapest && !isFareSelected && <i className="ri-medal-fill text-success fs-5"></i>}
                                          {isFareSelected && <i className="ri-checkbox-circle-fill text-white fs-5 shadow-sm"></i>}
                                        </div>

                                        {/* Middle Section: FULL DATA GRID (2x2) */}
                                        <div className="border-top border-bottom py-2 my-2" style={{ borderColor: isFareSelected ? 'rgba(255,255,255,0.2)' : '#f1f1f1' }}>

                                          {/* Row 1: Refundable & Meal */}
                                          <div className="row g-0 mb-2">
                                            <div className="col-6 border-end text-center" style={{ borderColor: isFareSelected ? 'rgba(255,255,255,0.2)' : '#f1f1f1' }}>
                                              <i className={`ri-refresh-line ${isFareSelected ? 'text-white' : (fare.dcAdults?.refundable === "Refundable" ? 'text-success' : 'text-danger')}`}></i>
                                              {/* FIX 1: Updated labels to REFUNDABLE / NON-REFUNDABLE */}
                                              <div style={{ fontSize: '8px' }} className="fw-bold px-1 text-uppercase">
                                                {fare.dcAdults?.refundable === "Refundable" ? 'REFUNDABLE' : 'NON-REFUNDABLE'}
                                              </div>
                                            </div>
                                            <div className="col-6 text-center px-1">
                                              <i className={`ri-restaurant-line ${isFareSelected ? 'text-white' : (fare.dcAdults?.mealType === "Free Meal" ? 'text-warning' : 'text-danger')}`}></i>
                                              <div style={{ fontSize: '8px' }} className="fw-bold text-uppercase">{fare.dcAdults?.mealType}</div>
                                            </div>
                                          </div>

                                          {/* Row 2: Cabin & Check-in Baggage */}
                                          <div className="row g-0 border-top pt-2" style={{ borderColor: isFareSelected ? 'rgba(255,255,255,0.1)' : '#f1f1f1' }}>
                                            <div className="col-6 border-end text-center" style={{ borderColor: isFareSelected ? 'rgba(255,255,255,0.2)' : '#f1f1f1' }}>
                                              <i className={`ri-handbag-line ${isFareSelected ? 'text-white' : 'text-muted'}`}></i>
                                              <div style={{ fontSize: '8px' }} className="fw-bold px-1">Cabin: {fare.cabinBaggage}</div>
                                            </div>
                                            <div className="col-6 text-center px-1">
                                              <i className={`ri-briefcase-4-line ${isFareSelected ? 'text-white' : 'text-muted'}`}></i>
                                              <div style={{ fontSize: '8px' }} className="fw-bold">Checkin: {fare.checkinBag}</div>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Bottom: Pricing */}
                                        <div className="text-center">
                                          <div className={`small fw-bold mb-0 ${isFareSelected ? 'text-white-50' : 'text-muted'}`} style={{ fontSize: '10px' }}>TOTAL FARE</div>
                                          {/* FIX 2: Added text-white to ensure visibility on blue background */}
                                          <div className={`d-flex align-items-center justify-content-center gap-1 ${isFareSelected ? 'text-white' : 'text-dark'}`}>
                                            <span className="small opacity-75">{currency}</span>
                                            <h4 className="fw-black mb-0" style={{ fontSize: '22px' }}>{fare.totalPrice.toLocaleString()}</h4>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              <style>{`
      .custom-horizontal-scrollbar::-webkit-scrollbar { height: 6px; }
      .custom-horizontal-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
      .custom-horizontal-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
      .custom-horizontal-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
    `}</style>
                            </div>
                          )}
                          {/* MODAL SECTION (Fixed: Placed inside map) */}
                          {/* UPGRADED FLIGHT DETAILS MODAL (WITH ALL DATA) */}
                          <div id={"flight" + flightLeg.supplierLegId} className="modal fade" role="dialog" aria-hidden="true">
                            <div className="modal-dialog modal-lg modal-dialog-centered">
                              <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '24px' }}>

                                {/* 1. Modal Header */}
                                <div className="modal-header border-bottom-0 p-4 pb-0">
                                  <h5 className="modal-title fw-bold text-dark fs-4">Flight Details</h5>
                                  <button type="button" className="btn-close shadow-none" data-bs-dismiss="modal"></button>
                                </div>

                                <div className="modal-body p-4">
                                  {/* 2. Journey Overview Header */}
                                  <div className="bg-light p-3 rounded-4 d-flex justify-content-between align-items-center mb-4 border">
                                    <div className="fw-bolder fs-5 text-dark">
                                      {mainLeg?.startSegment?.city}
                                      <i className="ri-arrow-right-line mx-3 text-primary"></i>
                                      {mainLeg?.endSegment?.city}
                                    </div>
                                    <div className="text-muted small fw-bold text-uppercase ls-1">
                                      <i className="ri-calendar-line me-1"></i> {moment(mainLeg?.startSegment?.departureDateTime).format("DD MMM YYYY")}
                                    </div>
                                  </div>

                                  {/* 3. Segments Loop */}
                                  <div className="flight-segments">
                                    {flightLeg.dcSegments.map((seg, sIdx) => (
                                      <React.Fragment key={sIdx}>
                                        <div className="row g-4 align-items-start py-4">

                                          {/* Column A: Airline Info */}
                                          <div className="col-lg-3 text-center text-lg-start border-end-lg">
                                            <div className="d-flex align-items-center flex-column flex-lg-row gap-2">
                                              <img
                                                src={"/assets/images/airlinelogos/" + seg?.tFAirlineData?.airlineCode + ".png"}
                                                width="45"
                                                className="rounded-2 shadow-sm p-1 border bg-white"
                                              />
                                              <div>
                                                <div className="fw-bolder text-dark mb-0">{seg.tFAirlineData?.airline}</div>
                                                <div className="text-muted small fw-bold">
                                                  {seg.tFAirlineData?.equimentType} • {seg.tFAirlineData?.flightNumber}
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Column B: Departure */}
                                          <div className="col-lg-3 text-center">
                                            <div className="fw-black text-dark fs-3 mb-0">
                                              {moment(seg.tFDepartureData.departureDateTime).format("HH:mm")}
                                            </div>
                                            <div className="fw-bolder text-primary mb-1">{seg.tFDepartureData.airportCode}</div>
                                            <div className="small text-muted fw-medium px-2" style={{ lineHeight: '1.2' }}>
                                              {seg.tFDepartureData.airportName}, {seg.tFDepartureData.city}
                                            </div>
                                            {seg.tFDepartureData.terminal && (
                                              <span className="badge bg-light text-dark border mt-2">Terminal {seg.tFDepartureData.terminal}</span>
                                            )}
                                          </div>

                                          {/* Column C: Duration Visual */}
                                          <div className="col-lg-3 text-center d-flex flex-column align-items-center justify-content-center">
                                            <div className="text-muted small fw-bold mb-1">{getTimeFromMins(seg?.tFAirlineData?.duration)}</div>
                                            <div className="d-flex align-items-center w-100 px-3 opacity-50">
                                              <div className="border-bottom border-secondary flex-grow-1" style={{ height: '1px' }}></div>
                                              <i className="ri-plane-fill mx-2 text-primary fs-5"></i>
                                              <div className="border-bottom border-secondary flex-grow-1" style={{ height: '1px' }}></div>
                                            </div>
                                            <div className="small text-muted mt-1 fw-medium">Duration</div>
                                          </div>

                                          {/* Column D: Arrival */}
                                          <div className="col-lg-3 text-center">
                                            <div className="fw-black text-dark fs-3 mb-0">
                                              {moment(seg.tFArrivalData.arrivalDateTime).format("HH:mm")}
                                            </div>
                                            <div className="fw-bolder text-primary mb-1">{seg.tFArrivalData.airportCode}</div>
                                            <div className="small text-muted fw-medium px-2" style={{ lineHeight: '1.2' }}>
                                              {seg.tFArrivalData.airportName}, {seg.tFArrivalData.city}
                                            </div>
                                            {seg.tFArrivalData.terminal && (
                                              <span className="badge bg-light text-dark border mt-2">Terminal {seg.tFArrivalData.terminal}</span>
                                            )}
                                          </div>
                                        </div>

                                        {/* 4. Layover / Connecting Time Logic (From your old code) */}
                                        {seg?.tFAirlineData?.connectingTime !== 0 && (
                                          <div className="my-2 px-4 py-2 bg-warning-subtle rounded-pill d-flex align-items-center justify-content-center gap-2 border border-warning-subtle">
                                            <i className="ri-time-line text-warning fw-bold"></i>
                                            <span className="small fw-bold text-dark">
                                              Layover in {seg.tFArrivalData.city}: {getTimeFromMins(seg?.tFAirlineData?.connectingTime)}
                                            </span>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </div>
                                </div>

                                {/* 5. Trust Footer */}
                                <div className="modal-footer border-top-0 p-4 bg-light rounded-bottom-4 justify-content-center">
                                  <p className="small text-muted mb-0">
                                    <i className="ri-information-fill me-1"></i> Check-in baggage & meals vary by supplier. Please verify on the next step.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>)}
            {/* end col */}
          </div>
          {/* end row */}
        </div>
        {/* container-fluid */}
      </div>
      {pageLoading === false ?
        (Object.keys(selectedFares).length > 0 ? (
          <div className="round-trip-fare fixed-bottom bg-dark shadow-md text-light">
            <div className="container p-2">
              <div className="row align-items-center">
                <div className="col-9">
                  <div className="row">
                    {Object.entries(selectedFares).map(([journeyType, sf]) => (
                      <div
                        key={journeyType}
                        className={
                          "border-right border-dark" +
                            Object.keys(selectedFares).length >
                            1
                            ? "col-sm-6"
                            : "col-sm-12"
                        }
                      >
                        <div className="row align-items-center flex-row">
                          <div className="col col-sm-4 col-md-3 text-center d-lg-flex company-info">
                            <span className="align-middle d-none d-sm-block">
                              <img
                                className="img-fluid me-2"
                                alt
                                width={"30px"}
                                height={"30px"}
                                src={`/assets/images/airlinelogos/${sf.flightLeg?.dcDisplayLegs[0]?.airlineData?.airlineCode}.png`}
                              />
                            </span>
                            <span className="align-middle ml-lg-2">
                              <span className="d-block text-1">
                                {
                                  sf.flightLeg?.dcDisplayLegs[0]?.airlineData
                                    ?.airline
                                }
                              </span>
                              <small className="text-white d-block">
                                {
                                  sf.flightLeg?.dcDisplayLegs[0]?.airlineData
                                    ?.airlineCode
                                }
                                -
                                {
                                  sf.flightLeg?.dcDisplayLegs[0]?.airlineData
                                    ?.flightNumber
                                }
                              </small>
                            </span>
                          </div>
                          <div className="col col-sm-4 col-md-3 text-center time-info">
                            <span className="text-4">
                              {moment(
                                sf.flightLeg?.dcDisplayLegs[0]?.startSegment?.departureDateTime
                              ).format("HH:mm")}
                            </span>
                            <small className="text-white d-none d-lg-block">
                              {sf.flightLeg?.dcDisplayLegs[0]?.startSegment?.city}
                            </small>
                          </div>
                          <div className="col col-sm-4 col-md-3 text-center time-info">
                            <span className="text-4">
                              {moment(
                                sf.flightLeg?.dcDisplayLegs[0]?.endSegment?.arrivalDateTime
                              ).format("HH:mm")}
                            </span>
                            <small className="text-white d-none d-lg-block">
                              {sf.flightLeg?.dcDisplayLegs[0]?.endSegment?.city}
                            </small>
                          </div>
                          <div className="col-md-3 text-center d-none d-md-block time-info">
                            <span className="text-1">
                              {Math.floor(
                                sf.flightLeg?.dcDisplayLegs[0]?.totalDuration / 60
                              )}
                              h{" "}
                              {sf.flightLeg?.dcDisplayLegs[0]?.totalDuration % 60}
                              m
                            </span>
                            <small className="text-white d-block">
                              Non Stop
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-3">
                  <div className="row align-items-center">
                    <div className="col-12 col-md-6 text-light text-center text-6 price">
                      <span className="text-1 text-white d-none d-lg-block">
                        Total Fare:{" "}
                      </span>
                      {currency}{" "}
                      {Object.values(selectedFares)
                        .reduce((sum, sf) => sum + (sf.fare?.totalPrice || 0), 0)
                        .toFixed(2)}
                    </div>
                    <div className="col-12 col-md-6 text-center mt-2 mt-md-0 btn-book">
                      <button
                        onClick={handleSubmit}
                        className="btn btn-sm btn-primary px-sm-2 px-lg-3"
                      >
                        <i className="fas fa-shopping-cart d-block d-lg-none" />
                        <span className="d-none d-lg-block">Book Now</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )) : ""}
      <BookingConfirmationModal
        show={showBookingModal}
        onHide={() => setShowBookingModal(false)}
        onContinue={handleContinueBooking}
        onBookWithSupplier={handleBookWithSupplier}
      />
    </div>
  );
};

export default Flights;
